module.exports = __webpack_public_path__ + "static/media/Statua_040.0dce2a16.jpg";